import ConsoleApi from "@/consoleapi/consoleApi";

import {AxiosResponse} from "axios";
/**
 *
 */
export default class Charge extends ConsoleApi {
    protected readonly resource = '/credit';

    /**
     * @param accountId
     * @param cardNumber
     * @param expiryYear
     * @param expiryMonth
     * @param cardUsername
     * @param phoneNumber
     * @param emailAddr
    */
    public post(accountId: string, cardNumber: string, expiryYear: string, expiryMonth: string, cardUsername: string, phoneNumber: string, emailAddr: string): Promise<AxiosResponse> {
      return this.axios.post(this.requestUri + this.getAccountResource(accountId),{
          "card_number": cardNumber,
          "expiry_year": expiryYear,
          "expiry_month": expiryMonth,
          "card_username": cardUsername,
          "phone_number": phoneNumber,
          "email_addr": emailAddr
      }, {
          headers: {
              Authorization: `Bearer ${this.bearerToken}`,
          },
      });
    }
}